
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wait-list",
      function () {
        return require("private-next-pages/wait-list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wait-list"])
      });
    }
  